export default __webpack_public_path__ + "static/media/Mobile-Slide-3.0d2ea7f1.jpg";